import React from "react";
import { motion } from "framer-motion";
import abrsm from "../images/landingPage/abrsm.webp";
import rockschool from "../images/landingPage/rockschool.webp";
import trinity from "../images/landingPage/trinity.webp";

const affiliations = [
  {
    name: "Trinity College London",
    tag: "International Graded Exams",
    logo: trinity,
  },
  {
    name: "Rockschool · RSL Awards",
    tag: "Contemporary Music Grades",
    logo: rockschool,
  },
  {
    name: "ABRSM",
    tag: "Classical Music Board",
    logo: abrsm,
  },
];

const cardVariant = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.12, ease: "easeOut" },
  }),
};

const Affiliations = () => {
  return (
    <section className="bg-white px-6 py-16 md:px-12">
      <div className="mx-auto max-w-6xl text-center">
        <span className="eyebrow mb-4">Recognised &amp; Certified</span>
        <h2 className="section-heading">Our Affiliations</h2>
        <p className="mx-auto mt-4 max-w-2xl text-ink-soft">
          An authorised examination centre preparing students for globally
          recognised music qualifications.
        </p>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {affiliations.map((item, i) => (
            <motion.div
              key={item.name}
              custom={i}
              variants={cardVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              whileHover={{ y: -6 }}
              className="group flex flex-col items-center rounded-2xl border border-gray-200 bg-white p-8 transition-shadow duration-300 hover:shadow-card"
            >
              <div className="flex h-20 w-full items-center justify-center">
                <img
                  src={item.logo}
                  alt={item.name}
                  className="max-h-16 w-auto max-w-[220px] object-contain opacity-70 grayscale transition duration-500 group-hover:opacity-100 group-hover:grayscale-0"
                  loading="lazy"
                />
              </div>
              <p className="mt-5 text-xs font-semibold uppercase tracking-[0.15em] text-ink-soft">
                {item.tag}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Affiliations;
